<template>
  <section class="wrap" @click="routeHome">
    <img
      class="options"
      src="../assets/icons/text/text-options.png"
      alt="text background android"
    />
    <span class="number">{{ phoneNumber }}</span>
    <section class="message-wrap previous">
      <section>
        <p class="blue">How are you doing?</p>
        <div class="date">Tues 3:12 PM</div>
      </section>
    </section>
    <section class="message-wrap first">
      <span class="avatar">
        <img src="../assets/icons/text/Untitled-1.png" alt="text icon" />
      </span>
      <section>
        <p class="grey">sorry dad - running late</p>
        <div class="date">Wed 10:18 AM</div>
      </section>
    </section>
    <section class="message-wrap second">
      <section>
        <p class="blue">ok drive safe and see you soon!</p>
        <div class="date">Wed 11:02 AM</div>
      </section>
    </section>
    <section class="message-wrap third">
      <span class="avatar">
        <img src="../assets/icons/text/Untitled-1.png" alt="text icon" />
      </span>
      <section>
        <p class="grey">thanks!</p>
        <div class="date">Wed 11:32 AM</div>
      </section>
    </section>
    <img
      class="bottom"
      src="../assets/icons/text/text-bottom.png"
      alt="text background android"
    />
  </section>
</template>

<script>
export default {
  name: "Text",
  methods: {
    routeHome() {
      this.$router.push({ path: `/home` })
    },
  },
  computed: {
    phoneNumber() {
      if (this.$route.params.name === "Sam Morris") {
        return "(313) 928-0198"
      } else return "(313) 272-1256"
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  height: 100%;
  width: 100%;
  background-color: #000;
  color: #fff;
  cursor: pointer;
}
.options {
  position: absolute;
  top: 44px;
  left: 0;
  width: 100%;
  object-fit: cover;
  z-index: 1;
}
.number {
  position: absolute;
  top: 5.25%;
  left: 15%;
  z-index: 2;
  font-size: 1.75rem;
}
.message-wrap {
  display: flex;
  text-align: left;

  img {
    width: 25px;
    height: auto;
  }

  p {
    font-size: 1.3rem;
    border-radius: 30px;
    width: fit-content;
    padding: 1rem;
    margin: 0 0 0 10px;
  }

  .date {
    padding-left: 30px;
  }
}
.grey {
  background-color: #707070;
}

.blue {
  background-color: #39b6ff;
}
.previous {
  position: absolute;
  top: 18%;
  right: 5%;
}
.first {
  position: absolute;
  top: 31%;
  left: 5%;

  .avatar {
    margin: 22px 0;
  }
}
.second {
  position: absolute;
  top: 44%;
  right: 5%;
}
.third {
  position: absolute;
  top: 54%;
  left: 5%;

  .avatar {
    margin: 22px 0;
  }
}
.avatar {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #39b6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom {
  position: absolute;
  bottom: 44px;
  left: 0;
  width: 100%;
}
</style>
